import { Spinner } from '@wartek-id/spinner'

import type { FC } from 'react'

type LoadingSpinnerProps = {}

const LoadingSpinner: FC<LoadingSpinnerProps> = () => {
  return (
    <div
      className="flex flex-col items-center justify-center gap-4 min-h-14"
      data-testid="loading-spinner"
    >
      <Spinner />
    </div>
  )
}

export default LoadingSpinner
